export interface Session {
  user: { id: string; name: string };
  mode: "oidc" | "development";
  expiresAt?: string;
}

let currentUser = "";
export function setSessionUser(id: string) { currentUser = id; }
export function sessionUser() { return currentUser; }
export const sessionExpiredEvent = "health-session-expired";
